import VaIcon from './components/va-icon'
import VaToast from './components/va-toast'
import VaButton from './components/va-button'
import VaInput from './components/va-input';
import VaSelect from './components/va-select';
import VaFileUpload from './components/va-file-upload';
import VaAvatar  from './components/va-avatar';
import VaCounter  from './components/va-counter';
import VaChip from './components/va-chip';
import iconsConfig from './icons-config/icons-config';
import { COLOR_THEMES } from './themes';

export default {
  components: {
    VaIcon,
    VaToast,
    VaButton,
    VaInput,
    VaSelect,
    VaFileUpload,
    VaAvatar,
    VaCounter,
    VaChip,
    ...COLOR_THEMES[0].components
  },
  colors: COLOR_THEMES[0].colors,
  icons: iconsConfig
}
